document.querySelectorAll('[toggle]').forEach(item => {
    item.addEventListener('click', event => {
        let el = event.target as HTMLInputElement;
        handleToggle(el, event)
    })
    
    item.addEventListener('change', event => {
        let el = event.target as HTMLInputElement;
        handleToggle(el, event)
    })
})

function handleToggle(el: HTMLElement, event: Event) {
    let al = el.closest('[toggle]') as HTMLInputElement
    
    if (al) {
        if (al.tagName == 'a')
            event.preventDefault()

        let toggleSelector = al.getAttribute('toggle')
        let targetEl = document.querySelector(toggleSelector ?? '') as HTMLElement
        let toggleClass = al.getAttribute('toggle-class')
        let toggleAddClass = al.getAttribute('toggle-add-class')
        let toggleRemoveClass = al.getAttribute('toggle-remove-class')
        let toggleBodyClass = al.getAttribute('toggle-body-class')
    
        if (toggleBodyClass) {
            document.body.classList.toggle(toggleBodyClass)
        }

        if (toggleAddClass) {
            targetEl.classList.add(toggleAddClass)
            targetEl.style.display = ''
            return
        }

        if (toggleRemoveClass) {
            targetEl.classList.remove(toggleRemoveClass)
            return
        }

        if (toggleClass) {
            targetEl.classList.toggle(toggleClass)
        }
        else if (targetEl) {
            targetEl.style.display = al.checked ? '' : 'none'
        }
    }
}